module.exports = __webpack_public_path__ + "static/media/icon_20px_sort.f66810f0.svg";